import { createAsyncThunk } from "@reduxjs/toolkit";
import apiAxios from "../../../services/apiAxios";
import {
    setReceipts,
    setLastCreatedReceipt,
    setReceiptLoading,
    setReceiptError,
    setSavedServices,
} from "../../Reducer/Receipt/ReceiptSlice";
import toast from "react-hot-toast";

export const createReceipt = createAsyncThunk(
    "receipt/createReceipt",
    async (receiptData, { dispatch }) => {
        dispatch(setReceiptLoading(true));
        try {
            const response = await apiAxios.post("/api/receipt/create", receiptData);
            if (response.status === 201) {
                dispatch(setLastCreatedReceipt(response.data.receipt));
                dispatch(fetchReceipts({ DID: receiptData.DID, page: 1, limit: 1 }));
                toast.success(response.data.message);
            }
            dispatch(setReceiptLoading(false));
            return response;
        } catch (error) {
            const message = error.response?.data?.error || error.message;
            toast.error(message);
            dispatch(setReceiptError(message));
            dispatch(setReceiptLoading(false));
            return error;
        }
    }
);

export const fetchReceipts = createAsyncThunk(
    "receipt/fetchReceipts",
    async ({ DID, page = 1, limit = 5, search = "" }, { dispatch }) => {
        try {
            const params = new URLSearchParams({ DID, page, limit });
            if (search) params.append("search", search);
            const response = await apiAxios.get(`/api/receipt/list?${params.toString()}`);
            if (response?.data) {
                dispatch(setReceipts(response.data));
            }
            return response?.data;
        } catch (error) {
            dispatch(setReceiptError(error.toString()));
            return error;
        }
    }
);

export const shareReceiptOnWhatsapp = createAsyncThunk(
    "receipt/shareReceipt",
    async (shareData, { dispatch }) => {
        dispatch(setReceiptLoading(true));
        try {
            const response = await apiAxios.post("/api/receipt/share", shareData);
            if (response.status === 200) {
                toast.success("Receipt shared on WhatsApp successfully");
            }
            dispatch(setReceiptLoading(false));
            return response;
        } catch (error) {
            const message = error.response?.data?.error || error.message;
            toast.error(message);
            dispatch(setReceiptError(message));
            dispatch(setReceiptLoading(false));
            return error;
        }
    }
);

// ─── Doctor Services Thunks ───

export const fetchSavedServices = createAsyncThunk(
    "receipt/fetchSavedServices",
    async ({ DID }, { dispatch }) => {
        try {
            const response = await apiAxios.get(`/api/receipt/services?DID=${DID}`);
            if (response?.data?.services) {
                dispatch(setSavedServices(response.data.services));
            }
            return response?.data;
        } catch (error) {
            console.error("Error fetching saved services:", error);
            return error;
        }
    }
);

export const syncSavedServices = createAsyncThunk(
    "receipt/syncSavedServices",
    async ({ DID, services }, { dispatch }) => {
        dispatch(setReceiptLoading(true));
        try {
            const response = await apiAxios.put("/api/receipt/services/sync", { DID, services });
            if (response?.data?.services) {
                dispatch(setSavedServices(response.data.services));
                toast.success("Services saved successfully");
            }
            dispatch(setReceiptLoading(false));
            return response?.data;
        } catch (error) {
            const message = error.response?.data?.error || error.message;
            toast.error(message);
            dispatch(setReceiptLoading(false));
            return error;
        }
    }
);

